(function () {
  var BRASS = '#A9793F';
  var WARM_BLACK = '#14110D';
  var IVORY = '#F8F3E8';
  var SENTIMENT_PAGE = '/pages/the-sentiment-library';
  var SENTIMENT_VARIANT_ID = 45848631607340;
  // Line-item property that records which gift a sentiment is for (shows in the cart and on the order).
  var BELONGS_TO = 'This sentiment belongs to';

  // One sentiment is expected per gift. optedOut remembers which missing-sentiment gifts the shopper
  // has ticked "no thank you" for (keyed by gift name). Persisted across the poll re-renders.
  var optedOut = {};

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // --- Cart maths: which gifts exist, which sentiments cover them, which gifts are still missing one ---
  function giftLabel(item) {
    var v = item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
    return item.product_title + v;
  }

  function analyzeCart(cart) {
    var pool = [];       // one entry per gift unit, in cart order
    var sentimentLines = [];
    var gifts = 0;
    var sentiments = 0;

    (cart.items || []).forEach(function (i) {
      if (i.variant_id === SENTIMENT_VARIANT_ID) {
        sentimentLines.push(i);
        sentiments += i.quantity;
      } else {
        gifts += i.quantity;
        for (var q = 0; q < i.quantity; q++) pool.push(giftLabel(i));
      }
    });

    // Sentiments that already say which gift they belong to claim that gift first
    var unassigned = [];
    sentimentLines.forEach(function (s) {
      var label = s.properties && s.properties[BELONGS_TO];
      for (var q = 0; q < s.quantity; q++) {
        var idx = label ? pool.indexOf(label) : -1;
        if (idx > -1) {
          pool.splice(idx, 1);
        } else {
          unassigned.push({ line: s, hadLabel: !!label });
        }
      }
    });

    // Sentiments with no (or an out-of-date) label cover the remaining gifts in order
    var toLabel = [];
    unassigned.forEach(function (u) {
      if (pool.length) {
        var assigned = pool.shift();
        if (!u.hadLabel && u.line.quantity === 1) toLabel.push({ line: u.line, label: assigned });
      }
    });

    return { gifts: gifts, sentiments: sentiments, missing: pool, sentimentLines: sentimentLines, toLabel: toLabel };
  }

  function optKey(missing, k) {
    var label = missing[k];
    var n = 0;
    for (var j = 0; j < k; j++) { if (missing[j] === label) n++; }
    return label + '#' + n;
  }

  // --- Banner: shown on the shop page after a sentiment is saved with no product yet ---
  function maybeShowSentimentBanner() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('sentiment_saved') !== '1') return;

    var banner = document.createElement('div');
    banner.setAttribute('id', 'sentiment-saved-banner');
    banner.style.cssText = [
      'background:' + WARM_BLACK,
      'color:' + IVORY,
      'font-family: "Instrument Sans", Arial, sans-serif',
      'font-size: 13px',
      'letter-spacing: 0.5px',
      'text-align: center',
      'padding: 16px 24px',
      'display: flex',
      'align-items: center',
      'justify-content: center',
      'gap: 18px',
      'flex-wrap: wrap',
      'border-bottom: 1px solid ' + BRASS
    ].join(';');

    var text = document.createElement('span');
    text.innerHTML = 'Your sentiment has been saved — <em style="font-style:italic;color:' + BRASS + '">choose your gift below</em> to complete it.';

    var dismiss = document.createElement('button');
    dismiss.textContent = 'Dismiss';
    dismiss.style.cssText = [
      'background:none',
      'border:1px solid rgba(255,255,255,0.4)',
      'color:' + IVORY,
      'font-size: 11px',
      'letter-spacing: 1.5px',
      'text-transform: uppercase',
      'padding: 6px 14px',
      'cursor: pointer'
    ].join(';');
    dismiss.onclick = function () { banner.remove(); };

    banner.appendChild(text);
    banner.appendChild(dismiss);

    var main = document.getElementById('main') || document.body;
    main.insertBefore(banner, main.firstChild);

    params.delete('sentiment_saved');
    var newSearch = params.toString();
    var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  // --- Sentiment Library page: choosing a sentiment ---
  // The library page's own script removes every existing sentiment before adding the new one, which
  // would wipe the first gift's sentiment when a second is added. This replaces that one function so that:
  //   - if a gift still has no sentiment, the new one is ADDED alongside the others (and tagged with that gift)
  //   - if the shopper used "Change your sentiment" (?replace=...), only that one is replaced
  //   - if every gift already has one and they choose again, the most recent one is replaced
  function installLibraryOverride() {
    if (typeof window.selectSentiment !== 'function') return;

    window.selectSentiment = async function (message, btn, card) {
      var originalText = btn.textContent;
      btn.textContent = 'Adding to your gift…';
      btn.disabled = true;
      try {
        var cart = await (await fetch('/cart.js')).json();
        var info = analyzeCart(cart);
        var params = new URLSearchParams(window.location.search);
        var replaceKey = params.get('replace');
        var forLabel = params.get('for');
        var toRemove = [];
        var label = null;

        if (replaceKey) {
          toRemove = info.sentimentLines.filter(function (l) { return l.key === replaceKey; });
          if (toRemove.length) label = (toRemove[0].properties || {})[BELONGS_TO] || null;
        } else if (info.missing.length) {
          label = forLabel && info.missing.indexOf(forLabel) > -1 ? forLabel : info.missing[0];
        } else if (info.sentimentLines.length) {
          toRemove = [info.sentimentLines[info.sentimentLines.length - 1]];
          label = (toRemove[0].properties || {})[BELONGS_TO] || null;
        }

        for (var n = 0; n < toRemove.length; n++) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: toRemove[n].key, quantity: 0 })
          });
        }

        var properties = { 'Gift Message': message };
        if (label) properties[BELONGS_TO] = label;

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: SENTIMENT_VARIANT_ID, quantity: 1, properties: properties }]
          })
        });

        if (info.gifts > 0) {
          window.location.href = '/cart';
        } else {
          window.location.href = '/collections/all?sentiment_saved=1';
        }
      } catch (e) {
        btn.textContent = originalText;
        btn.disabled = false;
        alert('Something went wrong adding your sentiment. Please try again.');
      }
    };
  }

  // --- Cart drawer / cart page: reminder + opt-out gate + change-sentiment link ---

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function findCheckoutButtons() {
    var all = document.querySelectorAll('a, button, input[type="submit"]');
    var found = [];
    all.forEach(function (el) {
      var txt = (el.value || el.textContent || '').trim().toLowerCase();
      if (/^checkout\b/.test(txt) && isVisible(el)) {
        found.push(el);
      }
    });
    return found;
  }

  function removeExisting(container, cls) {
    var existing = container.querySelectorAll('.' + cls);
    existing.forEach(function (e) { e.remove(); });
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // key = opt-out key; giftName = which gift this reminder is for; totalGifts = how many gifts are in the cart
  function buildReminder(key, giftName, totalGifts) {
    var wrap = document.createElement('div');
    wrap.className = 'sentiment-reminder';
    wrap.style.cssText = [
      'background:' + IVORY,
      'border:2px solid ' + BRASS,
      'color:' + WARM_BLACK,
      'font-family:"Instrument Sans", Arial, sans-serif',
      'font-size:15px',
      'font-weight:600',
      'letter-spacing:0.3px',
      'text-align:center',
      'padding:18px 16px',
      'margin:0 0 16px 0',
      'line-height:1.5'
    ].join(';');

    var many = totalGifts > 1;
    var forGift = many ? ' for ' + escapeHtml(giftName) : '';
    var href = SENTIMENT_PAGE + (many ? '?for=' + encodeURIComponent(giftName) : '');

    var message = document.createElement('div');
    message.innerHTML = '🔔 Don\'t forget your sentiment' + forGift + ' — <a href="' + href + '" style="color:' + BRASS + ';text-decoration:underline;font-weight:700;">add one</a>';
    wrap.appendChild(message);

    var optOutRow = document.createElement('label');
    optOutRow.style.cssText = [
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'gap:8px',
      'margin-top:14px',
      'font-size:12px',
      'font-weight:400',
      'letter-spacing:0.2px',
      'cursor:pointer',
      'color:' + WARM_BLACK
    ].join(';');

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'sentiment-optout-checkbox';
    checkbox.checked = !!optedOut[key];
    checkbox.style.cssText = 'width:16px;height:16px;cursor:pointer;flex-shrink:0;';
    checkbox.addEventListener('change', function () {
      optedOut[key] = checkbox.checked;
      wrap.classList.toggle('sentiment-reminder--satisfied', checkbox.checked);
    });

    var labelText = document.createElement('span');
    labelText.textContent = many
      ? 'No thank you, I don\'t want to add a personalised message to ' + giftName
      : 'No thank you, I don\'t want to add a personalised message to this gift';

    optOutRow.appendChild(checkbox);
    optOutRow.appendChild(labelText);
    wrap.appendChild(optOutRow);

    if (optedOut[key]) {
      wrap.classList.add('sentiment-reminder--satisfied');
    }

    return wrap;
  }

  function buildChangeLink(lineKey) {
    var link = document.createElement('a');
    link.href = SENTIMENT_PAGE + (lineKey ? '?replace=' + encodeURIComponent(lineKey) : '');
    link.className = 'sentiment-change-link';
    link.textContent = 'Change your sentiment';
    link.style.cssText = [
      'display:inline-block',
      'margin-top:6px',
      'font-family:"Instrument Sans", Arial, sans-serif',
      'font-size:11px',
      'letter-spacing:1px',
      'text-transform:uppercase',
      'color:' + BRASS,
      'text-decoration:underline',
      'cursor:pointer'
    ].join(';');
    return link;
  }

  // Returns true if any gift still needs its sentiment step resolved
  // (no sentiment attached to it, and the shopper hasn't ticked "no thank you" for it).
  function sentimentUnresolved(cart) {
    var info = analyzeCart(cart);
    for (var k = 0; k < info.missing.length; k++) {
      if (!optedOut[optKey(info.missing, k)]) return true;
    }
    return false;
  }

  function flashReminder() {
    var reminders = document.querySelectorAll('.sentiment-reminder');
    reminders.forEach(function (r) {
      r.style.transition = 'box-shadow 0.15s ease';
      r.style.boxShadow = '0 0 0 3px rgba(169,121,63,0.5)';
      r.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { r.style.boxShadow = 'none'; }, 900);
    });
  }

  function scanCartUI(cart) {
    var info = analyzeCart(cart);

    var checkoutButtons = findCheckoutButtons();
    checkoutButtons.forEach(function (btn) {
      var container = btn.parentElement || btn;
      removeExisting(container, 'sentiment-reminder');
      for (var k = 0; k < info.missing.length; k++) {
        container.insertBefore(buildReminder(optKey(info.missing, k), info.missing[k], info.gifts), btn);
      }
    });

    if (info.sentimentLines.length) {
      var containers = [];
      var candidates = document.querySelectorAll('dt, dd, li, span, p');
      candidates.forEach(function (el) {
        var txt = (el.textContent || '').trim();
        if (/^Gift Message\s*:?/i.test(txt) && txt.length < 200) {
          var container = el.closest('li') || el.parentElement || el;
          if (containers.indexOf(container) === -1) containers.push(container);
        }
      });
      containers.forEach(function (container, idx) {
        if (!container.querySelector('.sentiment-change-link')) {
          var line = info.sentimentLines[idx] || info.sentimentLines[info.sentimentLines.length - 1];
          container.appendChild(buildChangeLink(line ? line.key : ''));
        }
      });
    }
  }

  // A sentiment added before the gift (or before this feature) has no "belongs to" line yet.
  // Once there is a gift for it to cover, stamp it with that gift's name. One at a time, never retried.
  var labelingBusy = false;
  var labelAttempted = {};

  function autoLabelSentiments(cart) {
    if (labelingBusy) return;
    var info = analyzeCart(cart);
    var job = null;
    for (var i = 0; i < info.toLabel.length; i++) {
      if (!labelAttempted[info.toLabel[i].line.key]) { job = info.toLabel[i]; break; }
    }
    if (!job) return;

    labelAttempted[job.line.key] = true;
    labelingBusy = true;
    var props = {};
    var existing = job.line.properties || {};
    Object.keys(existing).forEach(function (k) { props[k] = existing[k]; });
    props[BELONGS_TO] = job.label;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: job.line.key, quantity: job.line.quantity, properties: props })
    })
      .then(function () { labelingBusy = false; pollCart(); })
      .catch(function () { labelingBusy = false; });
  }

  var CHECKOUT_BLOCK_MESSAGE_ONE = 'Please add a sentiment to your gift, or tick the box to confirm you don\'t want one, before checking out.';
  var CHECKOUT_BLOCK_MESSAGE_MANY = 'Please add a sentiment to each gift, or tick the box to confirm you don\'t want one, before checking out.';

  function blockMessage() {
    return analyzeCart(latestCart).gifts > 1 ? CHECKOUT_BLOCK_MESSAGE_MANY : CHECKOUT_BLOCK_MESSAGE_ONE;
  }

  // Blocks checkout (click on the checkout button, or a checkout form submit) whenever
  // a gift's sentiment step hasn't been resolved yet. Adding items to the cart is never blocked.
  function installCheckoutGate() {
    document.addEventListener('click', function (e) {
      var target = e.target.closest('a, button, input[type="submit"]');
      if (!target) return;
      var txt = (target.value || target.textContent || '').trim().toLowerCase();
      if (!/^checkout\b/.test(txt)) return;

      if (sentimentUnresolved(latestCart)) {
        e.preventDefault();
        e.stopPropagation();
        flashReminder();
        alert(blockMessage());
      }
    }, true); // capture phase so we intercept before the default navigation/submit

    document.addEventListener('submit', function (e) {
      if (!sentimentUnresolved(latestCart)) return;

      var action = (e.target.getAttribute('action') || '').split('?')[0].replace(/\/+$/, '');
      var submitter = e.submitter;
      var submitterText = submitter ? (submitter.value || submitter.textContent || '').trim().toLowerCase() : '';
      var isCheckoutSubmit = /^checkout\b/.test(submitterText) || (submitter && submitter.name === 'checkout') || /\/cart$/.test(action);

      // Only gate real checkout submits. Add-to-cart (/cart/add) and cart updates must always go through.
      if (!isCheckoutSubmit) return;

      e.preventDefault();
      e.stopPropagation();
      flashReminder();
      alert(blockMessage());
    }, true);
  }

  var latestCart = { items: [] };

  function pollCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        latestCart = cart;
        scanCartUI(cart);
        autoLabelSentiments(cart);
      })
      .catch(function () {});
  }

  onReady(function () {
    maybeShowSentimentBanner();
    installLibraryOverride();
    installCheckoutGate();
    pollCart();
    setInterval(pollCart, 1200);
  });
})();
